export enum ComponentId {
  PERPETRATOR_OWNER_NAME = "name",
  PERPETRATOR_OWNER_SURNAME = "surname",
  PERPETRATOR_OWNER_PHONE = "phone",
  PERPETRATOR_OWNER_EMAIL = "email",
  PERPETRATOR_OWNER_STREET = "street",
  PERPETRATOR_OWNER_STREET_2 = "street2",
  PERPETRATOR_OWNER_ZIP_CODE_PL = "zipCodePL",
  PERPETRATOR_OWNER_ZIP_CODE_GENERIC = "zipCodeGeneric",
  PERPETRATOR_OWNER_CITY = "city",
  PERPETRATOR_OWNER_COUNTRY = "country",
  PERPETRATOR_OWNER_PROVINCE = "province",
  PERPETRATOR_OWNER_REGISTRATION_NUMBER = "registrationNumber",
  PERPETRATOR_OWNER_MAKE = "make",
  PERPETRATOR_OWNER_MODEL = "model",
  PERPETRATOR_OWNER_OC_NUMBER = "ocNumber",
  PERPETRATOR_OWNER_INSURANCE_COMPANY = "insuranceCompany",
  PERPETRATOR_OWNER_DOCUMENTS = "documents",
}
